import React from 'react';
import { INikkeTierNode } from '../../../common/model/graphql-types';
import { RatingBox } from '../../../common/components/rating-box';

interface IProps {
  character: INikkeTierNode;
}

export const NikkePopoverRatings: React.FC<IProps> = ({ character }) => {
  return (
    <>
      {character.Slug === 'red-hood' && (
        <>
          <p className="hsr-role">
            Red Hood is a unique character who Burst in every stage. The ratings
            below show her potential when you use her as{' '}
            <strong className="role dps">
              {character.Burst_Type === 'I' && 'Burst I'}
              {character.Burst_Type === 'II' && 'Burst II'}
              {character.Burst_Type === 'III' && 'Burst III'}
            </strong>{' '}
            and for other ratings check her profile.
          </p>
        </>
      )}
      {character.Slug === 'rapi-red-hood' && (
        <>
          <p className="hsr-role">
            Rapi: Red Hood is a unique character who Burst multiple stages. The
            ratings below show her potential when you use her as{' '}
            <strong className="role dps">
              {character.Burst_Type === 'I' && 'Burst I'}
              {character.Burst_Type === 'III' && 'Burst III'}
            </strong>{' '}
            and for other ratings check her profile.
          </p>
        </>
      )}
      {character.Treasure === 'Yes' && (
        <>
          <p className="hsr-role">
            The ratings show the potential of a character if you equip them with
            their <strong className="teal">Favorite Treasure</strong>.
          </p>
        </>
      )}
      <div className="bottom ag">
        <div className="story-nikke with-margin">
          <RatingBox
            game="new-nikke"
            rating={character.Story_LD}
            ratingName="Story (low deficit)"
          />
          <RatingBox
            game="new-nikke"
            rating={character.Story_HD}
            ratingName="Story (high deficit)"
          />
        </div>
        <div className="story-nikke">
          <RatingBox
            game="new-nikke"
            rating={character.Boss}
            ratingName="Bossing"
          />
          <RatingBox game="new-nikke" rating={character.PVP} ratingName="PVP" />
        </div>
      </div>
    </>
  );
};
